/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-41
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_53 from /* 53 */"./53"
import * as /* [auto-meaningful-name] */Module_95 from /* 95 */"./95"
var Bp = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, [
    {
      type: "VisibleSwitch"
    }, {
      type: "DisabledSwitch"
    }
  ], {
    type: "InputTextGroup"
  }, {
    type: "InputSettingGroup"
  }, {
    type: "InputBackground"
  }, {
    type: "WidgetOpacity"
  }, {
    type: "Size",
    sizeRange: [[Module_95.m, Module_53.o], [Module_95.l, Module_53.m]]
  }, {
    type: "Coordinate"
  }
]
export { Bp }
